var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('page-header'),_c('page-content',[_c('tax-clearance-certificate-form')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }